import { render, staticRenderFns } from "./monthsale.vue?vue&type=template&id=6045f7bf"
import script from "./monthsale.vue?vue&type=script&lang=js"
export * from "./monthsale.vue?vue&type=script&lang=js"
import style0 from "./monthsale.vue?vue&type=style&index=0&id=6045f7bf&prod&lang=css"
import style1 from "./monthsale.vue?vue&type=style&index=1&id=6045f7bf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports